const calculateOffset = (page) => {
    return (page - 1) * 100;
};
export { calculateOffset };
